if (!__DEV__) {
  /**
   * Per gestire i `publicPath` dinamici per gli import di Webpack, ovvero
   * in caso in cui siamo in una sottocartella (configurazione
   * `httpServer.publicPath`).
   *
   * In questo modo gestiamo __dinamicamente__ il path di importazione, anche
   * per i chunk creati con il **Code Splitting**.
   */
  // @ts-ignore
  __webpack_public_path__ = (window.PUBLIC_PATH || '') + '/';
}
